import { render, staticRenderFns } from "./GenelRaporlamaView.vue?vue&type=template&id=025b1c1e"
import script from "./GenelRaporlamaView.vue?vue&type=script&lang=ts"
export * from "./GenelRaporlamaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports